enum Colors {
	WHITE = "#FFFFFF",
	BLACK = "#000000",

	GREY = "#7C7C7C",
	GREY_OPACITY_1 = "#e0e0e0",
	GREY_LIGHT = "#E6F4E5",
	GREY_LIGHT_2 = "#F5F5F5",
	GREY_F6 = "#F6F6F6",
	GREY_FA = "#FAFAFA",

	BLUE = "#2196F3",
	BLUE_DARK = "#01579B",
	BLUE_OPACITY_1 = "#E7EDFD",
	BLUE_OPACITY_2 = "#7B6CC421",
	BLUE_LIGHT = "#E7F5FD",
	BLUE_015 = "#01579B",
	BLUE_0B1 = "#0B1B35",
	BLUE_F1 = "#F1F4F9",
	BLUE_37 = "#37AEE2",

	ORANGE = "#FF9256",
	ORANGE_FFAA = "#FFAA7B",
	Orange_OPACITY_1 = "#FDF2D7",
	GOLD = "#FFD700",

	RED = "#FF4444",
	RED_LIGHT = "#FFD7D7",

	GREEN = "#3AAA35",
	GREEN_LIGHT = "#E1F2E0",
	GREEN_DARK = "#1B5E20",
	GREEN_OPACITY_1 = "#E5F6EC",
	GREEN_E6 = "#E6F4E5",

	PEOPLE = "#7B6CC4",
	PEOPLE_2 = "#483A8E",

	BROWN = "#3C3624",

	// OLD
	BLACK_OLD = "#161616",
	DARK_WHITE = "#F2F7F2",

	VIOLET = "#7B6CC4",
	LIGHT_VIOLET = "#F6F4FF",
	VIOLET_DE = "#dee6fc",

	GREY_OLD = "#FCFCFC",
	DARK_GREY = "#E8E8E8",
	DARK_GREY3 = "#C0C0C0",
	LIGHT_GREY = "#E5E5E5",

	PEOPLE_OLD = "#483A8E",
	RED_OLD = "#B92020",
	RED2 = "#A60000",
	RED_OPACITY = "#EFE0E0",

	GREEN_OPACITY = "#E3EEE2",
	TRANSPARENT = "transparent",
	YELLOW = "#FFD981",
	SCROLL_BACKGROUND = "#F5F5F5",

	SHADOW = "#7474741F",
}

export default Colors;
